module.exports = __webpack_public_path__ + "img/focusmassage.12bd4541.jpeg";